module.exports = __webpack_public_path__ + "static/media/icon_video_mic_off_red.bfdb10ba.svg";